<template>

  <div v-if="this.form">

    <el-table
    v-if="(this.localNew || this.isRequest) && this.form"
    :data="providers"
    border style="width: 100%"
    :highlight-current-row="editMode"
    max-height="250"
    @current-change="checked">

    <el-table-column width="40">
      <template #default="scope">
        <i v-if="form.backhaul_id === providers[scope.$index].id" class="fa fa-check"></i>
        <i v-else class="fa fa-nothing"></i>
      </template>
    </el-table-column>

    <el-table-column prop="backhaulType" label="Type" />
    <el-table-column prop="provider.shortName" label="Provider" />


    <el-table-column prop="backhaul.exclusive" label="Exclusive">
      <template #default="scope">
        <i :class="providers[scope.$index].exclusive ? 'fa fa-check-circle' : 'fa fa-minus-circle'" ></i>
      </template>
    </el-table-column>

    <el-table-column prop="backhaul.depositFee" label="Entrance">
      <template #default="scope">
        {{formatNumber(providers[scope.$index].depositFee)}}
      </template>
    </el-table-column>

    <el-table-column prop="backhaul.rightOfWayCharges" label="ROW">
      <template #default="scope">
        {{formatNumber(providers[scope.$index].rightOfWayCharges)}}
      </template>
    </el-table-column>
  </el-table>


    <el-row v-if="!this.form.site_id" :gutter="gutter">
      <el-col :span="24">
        <el-alert type="warning" title="Site Required" description="Please select a site to successfully save this provider." show-icon>
        </el-alert>
        <select-site v-model="form.site_id" no-form :disabled="disabled" />
      </el-col>
    </el-row>

    <edit-pane
      v-if="form.organisation_id"
      ref="bh"
      title="Backhaul Customer"
      :prefix="headerPrefix"
      :editable="canAccess('finance|admin') && isTowerCo()"
      :is-edit="editMode"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
      @add="onSave">

      <div class="padded">
        <el-form :label-position="this.isDesktop || this.isTablet ? 'top' : 'left'" label-width="134px">

          <el-row :gutter="gutter">

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <select-backhaul-status v-model="form.status" @change="resetDates" :disabled="disabled && isTowerCo()" />
            </el-col>

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <switch-input v-model="form.deposit" label="Entrance" :disabled="disabled && isTowerCo()"></switch-input>
            </el-col>

            <el-col :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <switch-input v-model="form.rightOfWay" label="Right of Way" :disabled="disabled && isTowerCo()"></switch-input>
            </el-col>

            <el-col v-if="localNew" class="bg-primary-lighten-1" style="border-radius: 8px" :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <date-input v-model="form.startService" label="Serivce Start" placeholder="Started" :disabled="disabled" />
            </el-col>

            <el-col v-if="form.status === 'Terminated'" class="bg-danger-lighten-2" style="border-radius: 8px" :sm="mq.sm" :md="mq.md" :lg="mq.lg">
              <date-input v-model="form.terminateService"
              label="Terminated"
              placeholder="Terminated"
              :disabled="disabled && isTowerCo()" />
            </el-col>

          </el-row>


          <el-collapse v-if="isTowerCo()" v-model="section" accordion>

            <!-- Contact Section -->
            <el-collapse-item name="1">
              <template #title>
                <span class="text-primary"><i><b>Contract</b></i> <span v-if="form.started">: <b>{{formatNumber(form.tenor, 0)}}</b> yr. from <b>{{formatDate(form.started)}}</b> to <b>{{formatDate(form.expiry)}}</b></span></span>
              </template>

              <el-row :gutter="gutter">

                <el-col :sm="24" :md="9">
                  <text-input placeholder="Contract No" v-model="form.contractNo" :disabled="disabled" />
                </el-col>

                <el-col :sm="24" :md="12" :lg="6">
                  <date-input v-model="form.started" placeholder="Started" :disabled="disabled" />
                </el-col>

                <el-col :sm="20" :md="9" :offset="1">
                  <el-form-item placeholder="Tenor">
                    <el-slider
                    v-model="tenor" :min="1" :max="24" :step="1" show-stops :show-input="!localNew"  :disabled="disabled">
                  </el-slider>
                </el-form-item>
              </el-col>


              <el-col :sm="24" :md="12" :lg="6">
                <el-form-item>
                  <b>{{formatFriendlyDate(form.expiry)}}</b> ({{formatDate(form.expiry)}})
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>



          <!-- Exclusive Section -->
          <el-collapse-item v-if="form.exclusive && canAccess('finance')" name="2">
            <template #title>
              <span class="text-primary"><i><b>Exclusivity</b></i> <span v-if="form.exclusiveExpiry">: expires on <b>{{formatDate(form.exclusiveExpiry)}}</b></span></span>
            </template>

            <el-row :gutter="gutter">

              <el-col :md="6">
                <number-input label="Fee"  v-model="form.exclusiveFee" placeholder="Fee" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <date-input v-model="form.exclusiveExpiry" label="Expiry" placeholder="Expiry" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <select-frequency  v-model="form.exclusiveFrequency" label="Frequency" placeholder="Frequency" :disabled="disabled" />
              </el-col>

            </el-row>
          </el-collapse-item>


          <!-- Entrance Section -->
          <el-collapse-item  v-if="form.deposit && canAccess('finance')" name="3">
            <template #title>
              <span class="text-primary"><i><b>Deposit / Entrance</b></i> <span v-if="form.depositPaid">: paid on <b>{{formatDate(form.depositPaid)}}</b></span></span>
            </template>
            <el-row :gutter="gutter">
              <el-col :span="6">
                <float-input label="Entrance Fee"  v-model="form.depositFee"  placeholder="Fee" :disabled="disabled" />
              </el-col>

              <el-col :span="12">
                <date-input v-model="form.depositPaid" label="Date Paid" placeholder="Date Paid" :disabled="disabled" />
              </el-col>

              <el-col :span="6">
                <text-input  v-model="form.depositRef" label="Ref" placeholder="Ref" :disabled="disabled" />
              </el-col>
            </el-row>
          </el-collapse-item>


          <!-- Right of Way Section -->
          <el-collapse-item v-if="form.rightOfWay && canAccess('finance')" name="4">
            <template #title>
              <span class="text-primary"><i><b>Right of Way</b></i><!-- <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b> to <b>{{formatDate(form.terminateService)}}</b></span> --></span>
            </template>
            <el-row :gutter="gutter">
              <el-col :md="6">
                <float-input v-model="form.rightOfWayCharges" label="Right of Way" placeholder="ROW Charges" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <float-input  v-model="form.exclusiveFee" label="Exclusive Fee" placeholder="Exclusive Fee" :disabled="disabled" />
              </el-col>

            </el-row>
          </el-collapse-item>


          <!-- Service Section -->
          <el-collapse-item name="5" v-if="!localNew">
            <template #title>
              <span class="text-primary"><i><b>Serivce</b></i> <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b><span v-if="form.terminateService"> to <b class="text-danger">{{formatDate(form.terminateService)}}</b></span></span></span>
            </template>
            <el-row :gutter="gutter">
              <el-col :md="6">
                <date-input v-model="form.startService" label="Serivce Start" placeholder="Started" :disabled="disabled" />
              </el-col>

              <el-col :md="6" :offset="2">
                <date-input v-model="form.terminateService"
                label="Terminated"
                placeholder="Terminated"
                :disabled="!editMode && (this.form.status =='Active')" />
              </el-col>
            </el-row>
          </el-collapse-item>


          <!-- Other Fees Section -->
          <el-collapse-item v-if="canAccess('finance')" name="6">
            <template #title>
              <span class="text-primary"><i><b>Sundry &amp; Other Fees</b></i><!-- <span v-if="form.startService">: from <b>{{formatDate(form.startService)}}</b> to <b>{{formatDate(form.terminateService)}}</b></span> --></span>
            </template>

            <el-col :md="6">
              <float-input label="Recurring Fee" v-model="form.recurringFee" placeholder="Sundry Fees" :disabled="disabled" />
            </el-col>

            <el-col :md="6" :offset="2">
              <select-frequency v-model="form.frequency" label="Frequency" :disabled="disabled" />
            </el-col>

          </el-collapse-item>

        </el-collapse>

    </el-form>

  </div>

  <div v-if="form.updated_at" class="pull-right">
    <span class="pull-right">Last update: <b>{{formatFriendlyDate(form.updated_at)}}</b> ({{formatDateTime(form.updated_at)}})<span v-if="form.updated_by"> by {{form.updated_by}}</span></span>
  </div>

</edit-pane>

<div v-else class="padded" >
  <el-alert title="Sharer isn't a customer for this provider" show-icon :closable="false" />
</div>

</div>

</template>


<script>


import SiteMixins from '@/mixins/SiteMixins'

import SelectBackhaulType from '@/components/atoms/selects/SelectBackhaulType'
import SelectBackhaulStatus from '@/components/atoms/selects/SelectBackhaulStatus'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'

import SelectSite from '@/components/atoms/selects/SelectSite'


export default {

  mixins: [SiteMixins],

  components: {
    SelectBackhaulType,
    SelectBackhaulStatus,
    SelectBackhaulProvider,
    SelectSite
  },


  props: {

    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },

    recordId: {
      type: Number,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    },

    sharerId: {
      type: Number,
      default: null
    },

    providerId: {
      type: Number,
      default: null
    },

    actionId: {
      type: Number,
      default: null
    },

    editable: {
      type: Boolean,
      default: false
    },

    isNew: {
      type: Boolean,
      default: false
    },

    isRequest: {
      type: Boolean,
      default: false
    },

    showEditButton: {
      type: Boolean,
      default: true
    },

    tableRef: {
      type: String,
      default: 'backhaultable'
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  computed: {

    // Header prefix for the EditPane title — names both parties of the backhaul
    // subscription: "<provider> : <customer>" (XOL-264). Both `provider` and
    // `subscriber` are appended by the API on a loaded subscriber record; each
    // part is dropped if absent so the header is never a bare ": Backhaul
    // Customer". EditPane renders "<prefix>: <title>", so the trailing
    // space makes the final separator read " : Backhaul Customer", giving
    // "<provider> : <customer> : Backhaul Customer".
    headerPrefix () {
      var f = this.form
      if (!f) return null
      var provider = f.provider ? (f.provider.shortName || f.provider.name) : null
      var customer = f.subscriber ? (f.subscriber.shortName || f.subscriber.name) : null
      var parts = []
      if (provider) parts.push(provider)
      if (customer) parts.push(customer)
      if (!parts.length) return null
      return parts.join(' : ') + ' '
    }

  },



  methods: {

    getBackhaul (data) {

      if (data && data[0]) {
        this.localNew = false
        this.form = data[0]

      } else {
        this.localNew = true
        this.form = this.getTableStruct('backhaul_subscribers')
        this.form.status = 'Pending'
        this.form.site_id = this.siteId
        this.form.organisation_id = this.sharerId
        this.form.action_id = this.actionId
      }

    },

    getProviders (data) {

      if (!this.checkWarning(data)) {
        this.providers = data
        this.form.provider_id = null
        this.form.providerShortName = null
      }

    },

    checked (val) {

      if (this.form) {
        if (val.provider_id) {
          this.form.backhaul_id = val.id
          this.form.provider_id = val.provider_id
          this.form.provider = {}
          this.form.backhaul = val
          this.form.provider.shortName = val.providerShortName
          this.form.provider.name = val.providerName
        } else {
          this.form.backhaul_id = null
          this.form.provider_id = null
          this.form.provider = {}
          this.form.backhaul = {}
        }

      }
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.disabled = false
      this.onSave()
    },

    onSave () {
      this.form.started = this.formatDateSql(this.form.started)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.form.exclusiveExpiry = this.formatDateSql(this.form.exclusiveExpiry)
      this.form.depositPaid = this.formatDateSql(this.form.depositPaid)

      this.form.startService = this.formatDateSql(this.form.startService)
      this.form.terminateService = this.formatDateSql(this.form.terminateService)

      if (!this.form.action_id && this.actionId) {
        this.form.action_id = this.actionId
      }

      this.saveForm(this, '/backhaul/subscribers', this.form.id, this.form, this.form.backhaulType, this.onClose)
      this.disabled = true
/*
      if (this.localNew) {
        this.$emit('save')
      }
*/
    },

    onClose () {

      if (this.tableRef && !this.isRequest) {
        this.$events.emit(this.tableRef + '-refresh-table')
      }

      if (this.$refs.backhaulAdd) {
        this.$refs.backhaulAdd.closeModal()
        this.form = this.getTableStruct('backhaul_subscribers')
      }

    },

    resetDates (value) {
      if (value !== 'Terminated') {
        this.form.terminateService = null
      }
    }

  },


  watch: {

    providerId: function (value) {
      this.editMode = (value !== null)
      this.form.provider_id = value
    },

    tenor: function (value) {
      if (this.form) {
        this.form.expiry = this.contractExpiryDate(this.form.started, this.tenor, 'years', 'YYYY-MM-DD')
        this.form.tenor = value
      }
    }

  },



  data () {

    return {
      localSiteId: (this.siteId || this.rowData.site_id),
      localNew: this.isNew,
      gutter: 32,
      mqAdd: {sm: 24, md: 24, lg: 8},
      mq: {sm: 24, md: 12, lg: 6},
      section: '1',
      disabled: !this.isNew,
      editMode: (this.editable && this.form.provider_id) || this.isNew,
      form: this.rowData ? this.rowData : this.getTableStruct('backhaul_subscribers'),
      tenor: 1,
      providers: null

    }

  },



  mounted () {

    if (this.isRequest) {
      this.localNew = (this.siteId && this.sharerId) ? true : false
      this.editMode = true
      this.disabled = false

      if (this.siteId && this.sharerId) {
        this.fetchData('backhaul/subscribers/site/' + this.siteId + '/org/' + this.sharerId,
        this.getBackhaul,
        'Backhaul subscriber')
      }
    }

    this.tenor = this.form.tenor ? Number(this.form.tenor) : 1

    this.findSiteBackhaulProviders(this.siteId, this.getProviders)

/*
    if (!this.form.provider_id && !this.form.backhaul_id) {
      this.findSiteBackhaulProviders(this.siteId, this.getProviders)
    }
*/

    if (this.localNew) {
      this.mq = this.mqAdd

      this.form.site_id = this.localSiteId

      if (this.sharerId) {
        this.form.organisation_id = this.sharerId
      } else {
        delete this.form.organisation_id
        delete this.form.organisation
      }

      if (this.providerId) {
        this.form.provider_id = this.providerId
      }

    }

  }
}

</script>
